import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

export const useStyles = () => ({
  root: {
    display: 'flex',
    width: '100%',
    gap: '16px',
    isolation: 'isolate',
    border: `1px solid ${COLORS.gray.light2}`,
    borderRadius: '8px',
    backgroundColor: COLORS.white.main,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
});
